import { faSlidersSimple } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Slider,
} from '@repo/videa-components/src/index';
import { cn } from '@repo/videa-components/src/lib/utils';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import {
  DEFAULT_MATERIALITY_FILTER_COUNTS,
  DEFAULT_MATERIALITY_FILTER_DOLLARS,
  DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_COUNTS,
  DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_DOLLARS,
} from '../../atoms';

export const MaterialityFilter = ({
  productionValue,
  opportunityValue,
  setProductionValue,
  setOpportunityValue,
  max,
  isCounts,
}: {
  productionValue: number;
  opportunityValue: number;
  setProductionValue: (value: number) => void;
  setOpportunityValue: (value: number) => void;
  max: number;
  isCounts: boolean;
}) => {
  const { trackEvent } = useTrackEvent();

  // Production
  const isDefaultProduction = isCounts
    ? productionValue === DEFAULT_MATERIALITY_FILTER_COUNTS
    : productionValue === DEFAULT_MATERIALITY_FILTER_DOLLARS;

  const currentProductionSliderValue = isCounts
    ? productionValue.toLocaleString()
    : `$${productionValue.toLocaleString()}`;

  const productionStringValue = isDefaultProduction
    ? currentProductionSliderValue
    : currentProductionSliderValue +
      ' (Default: ' +
      (isCounts
        ? DEFAULT_MATERIALITY_FILTER_COUNTS
        : '$' + DEFAULT_MATERIALITY_FILTER_DOLLARS) +
      ')';

  // Opportunity
  const isDefaultOpportunity = isCounts
    ? opportunityValue === DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_COUNTS
    : opportunityValue === DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_DOLLARS;

  const currentOpportunitySliderValue = isCounts
    ? opportunityValue.toLocaleString()
    : `$${opportunityValue.toLocaleString()}`;

  const opportunityStringValue = isDefaultOpportunity
    ? currentOpportunitySliderValue
    : currentOpportunitySliderValue +
      ' (Default: ' +
      (isCounts
        ? DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_COUNTS
        : '$' + DEFAULT_MATERIALITY_FILTER_OPPORTUNITY_DOLLARS) +
      ')';

  return (
    <Popover>
      <PopoverTrigger className="vai-w-12 vai-h-10">
        <Button
          className={cn(
            'vai-w-12 vai-h-10',
            isDefaultProduction && isDefaultOpportunity
              ? 'vai-bg-white hover:vai-bg-zinc-100'
              : 'vai-bg-sapphire-50 vai-text-primary hover:vai-bg-sapphire-100 hover:vai-text-primary',
          )}
          variant="outline"
        >
          <FontAwesomeIcon icon={faSlidersSimple} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="vai-bg-white vai-border-none vai-p-4">
        <div className="vai-flex vai-flex-col vai-gap-4">
          <div className="vai-w-64">
            <div className="vai-text-sm vai-text-slate-600 vai-mb-2">
              Minimum production by provider
            </div>
            <div className="vai-text-lg vai-font-medium vai-text-center vai-mb-2">
              {productionStringValue}
            </div>
            <Slider
              min={0}
              max={max}
              value={[productionValue]}
              step={max > 1000 ? 50 : 1}
              onValueChange={(values) => {
                setProductionValue(values[0]);
                trackEvent(mixpanelEvents.insightsMaterialityFilterChanged, {
                  value: values[0],
                  isCounts,
                });
              }}
            />
          </div>
          <div className="vai-w-64">
            <div className="vai-text-sm vai-text-slate-600 vai-mb-2">
              Minimum opportunity by provider
            </div>
            <div className="vai-text-lg vai-font-medium vai-text-center vai-mb-2">
              {opportunityStringValue}
            </div>
            <Slider
              min={0}
              max={max}
              value={[opportunityValue]}
              step={max > 1000 ? 50 : 1}
              onValueChange={(values) => {
                setOpportunityValue(values[0]);
                trackEvent(mixpanelEvents.insightsMaterialityFilterChanged, {
                  value: values[0],
                  isCounts,
                });
              }}
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
